import { Goal, ID } from '@griply/types';

export const getGoalAncestors = (goal: Goal, goals: Goal[]): Goal[] => {
  const goalsMap = new Map(goals.map((g) => [g.id, g]));
  const visited = new Set<ID>([goal.id]);

  const walk = (current: Goal): Goal[] => {
    const parentId = current.parentIds?.[current.parentIds.length - 1];
    if (!parentId) {
      return [];
    }
    const parent = goalsMap.get(parentId);
    if (!parent || visited.has(parent.id)) {
      return [];
    }
    visited.add(parent.id);
    return [...walk(parent), parent];
  };

  return walk(goal);
};
